import React from 'react';
import { string,func,object } from 'prop-types';
import style from './style';
import QuizSentenceBase from './QuizSentenceBase';


const QuizSentence = ({content, options, blankColor, onClickBlank, onAnnotation}) => {
	const Blank = onClickBlank ? style.ClickableBlank : style.Blank;
	return <QuizSentenceBase 
		content = {content}
		renderBlank={({answer, index})=>{
			let blankSize = 0;
			if(options && options[answer]){
				blankSize = options[answer].blankSize;
			}
			return (<Blank 
				key={answer}
				text={answer}
				blankSize={blankSize}
				annotation={onAnnotation&&onAnnotation(answer,index)}
				blankColor={blankColor}
				onClick={(e)=>{onClickBlank && onClickBlank(index,answer,e);}}
			/>);
		}}
	/>;
};
QuizSentence.propTypes = {
	content: string,
	blankColor : string,
	onAnnotation : func,
	onClickBlank : func,
	options : object
};

export default QuizSentence;